import { render, staticRenderFns } from "./lecto-favorite.vue?vue&type=template&id=1c529fc4"
import script from "./lecto-favorite.vue?vue&type=script&lang=js"
export * from "./lecto-favorite.vue?vue&type=script&lang=js"
import style0 from "./lecto-favorite.vue?vue&type=style&index=0&id=1c529fc4&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports